import { useParams } from 'react-router-dom';

import { useGetSalesReturnByIdQuery } from '@/features/slice/sales-return';

export const useSalesReturnDetails = () => {
    const params = useParams();
    const id = params.id as string;

    const { data, isLoading, isError, error, isFetching } =
        useGetSalesReturnByIdQuery(id);

    return {
        data,
        isLoading,
        isError,
        error,
        isFetching,
    };
};
